import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Stethoscope, Syringe, MessageSquareOff, HeartPulse } from 'lucide-react';
// Optimized Unsplash images: auto=format (webp/avif), moderate quality, cropped.
const cover = (id: string) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=600&h=400&q=60`;
const audiences = [{
  icon: <Stethoscope className="w-6 h-6" data-id="element-193" />,
  img: cover('1579684385127-1ef15d508118'),
  alt: 'Dermatóloga atendiendo en su consultorio propio',
  title: 'Dermatólogo/a con consultorio propio',
  description: 'Atendés en tu propio espacio y necesitás procesos que funcionen sin que estés presente todo el tiempo.'
}, {
  icon: <Syringe className="w-6 h-6" data-id="element-194" />,
  img: cover('1629909613654-28e377c37b09'),
  alt: 'Dermatóloga realizando un procedimiento estético',
  title: 'Dermatólogo/a con práctica estética',
  description: 'Hacés peelings, láser, toxina o rellenos y necesitás resguardo legal y presentación de presupuestos sin fricción.'
}, {
  icon: <MessageSquareOff className="w-6 h-6" data-id="element-195" />,
  img: cover('1584515933487-779824d29309'),
  alt: 'Dermatólogo respondiendo mensajes fuera de horario',
  title: 'Cansado/a del WhatsApp fuera de horario',
  description: 'Necesitás un filtro real para las consultas que hoy te comen la noche y el fin de semana.'
}, {
  icon: <HeartPulse className="w-6 h-6" data-id="element-196" />,
  img: cover('1594824476967-48c8b964273f'),
  alt: 'Dermatóloga con tiempo personal recuperado',
  title: 'Buscás recuperar tu tiempo personal',
  description: 'Querés que el consultorio funcione aunque vos ya te hayas ido a tu casa.'
}];
export function TargetAudience() {
  return <section className="py-12 md:py-24 bg-white" data-id="element-197">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-198">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-16 items-center" data-id="element-199">
          <div className="lg:w-1/3" data-id="element-200">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-201">
              <h2 className="text-xs md:text-sm font-bold text-brand-gold uppercase tracking-widest mb-2 md:mb-3" data-id="element-202">
                ¿Para quién es?
              </h2>
              <h3 className="text-2xl md:text-4xl font-serif font-bold text-brand-navy mb-3 md:mb-6" data-id="element-203">
                Diseñado para vos
              </h3>
              <p className="text-base md:text-lg text-slate-600 mb-6 md:mb-8" data-id="element-204">
                El sistema está pensado para resolver los problemas reales de la
                práctica dermatológica diaria en Argentina.
              </p>
              <div className="bg-brand-light p-4 md:p-6 rounded-xl border-l-4 border-brand-gold" data-id="element-205">
                <p className="text-sm md:text-base font-medium text-brand-navy" data-id="element-206">
                  ¿No estás seguro/a? Tenés 7 días de garantía para probarlo en
                  tu consultorio.
                </p>
              </div>
            </motion.div>
          </div>

          <div className="lg:w-2/3 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 w-full" data-id="element-207">
            {audiences.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} whileHover={{
            y: -6
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="group rounded-2xl bg-white border border-slate-200 shadow-sm hover:shadow-xl hover:border-brand-gold/50 transition-all cursor-default overflow-hidden" data-id="element-208">
                <div className="relative h-40 md:h-44 overflow-hidden" data-id="element-209">
                  <img src={item.img} alt={item.alt} loading="lazy" decoding="async" width={600} height={400} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-210" />
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/70 via-brand-navy/10 to-transparent" data-id="element-211" />
                  <div className="absolute bottom-3 left-3 w-11 h-11 rounded-xl bg-brand-gold text-brand-navy flex items-center justify-center shadow-lg" data-id="element-212">
                    {item.icon}
                  </div>
                </div>
                <div className="p-5 md:p-6" data-id="element-213">
                  <h4 className="text-lg md:text-xl font-bold text-brand-navy mb-2" data-id="element-214">
                    {item.title}
                  </h4>
                  <p className="text-sm md:text-base text-slate-600" data-id="element-215">
                    {item.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}